<template>
    <div class="table-responsive product-status">
        <table class="table table-striped table-bordered mb-2">
            <thead>
            <tr>
                <th style="width: 70px">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="checkAll" name="checkAll"
                               v-model="checkAll"
                               v-on:click="checkAllEvent($event)">
                        <label class="custom-control-label" for="checkAll">All</label>
                    </div>
                </th>
                <th>Quote #</th>
                <th>Item #</th>
                <th>Product Name and Description</th>
                <th>Qty Tier</th>
                <th>
                    <select class="form-control" v-model="qty_unit_id">
                        <option value="">Select UOM</option>
                        <option v-for="(qtyUnit, unitIndex) in quantityUnits" :value="qtyUnit.id">
                            {{ qtyUnit.name }}
                        </option>
                    </select>
                </th>
                <th>Retail price</th>
                <th>Status</th>
            </tr>
            </thead>
            <SelectedProducts :key="'test_'+10" :products="products"
                              :selected-products="selectedProducts"
                              :is-quote="true"
                              :quantity-units="quantityUnits"
                              :bus="bus"
                              :product-data="productData"
                              @removeProductCheckbox="removeProductCheckbox"
                              @watchChangedProducts="updateProducts"></SelectedProducts>
            <!--<tbody name="product-table" is="transition-group">-->
            <tbody name="product-table">
            <template v-if="productData">

                <template v-for="(product, index) in productData.products.data">
                    <template v-if="products.filter((y) => y.quote_product_id == product.id).length == 0">
                        <tr class="product-table-item" :class="[selectedProducts.includes(product.id) ? 'active-row' : '']"
                            :id="products.length + index" :key="products.length + index">
                            <td>
                                <div class="custom-control custom-checkbox">
                                    <input :value="product.id" type="checkbox" class="custom-control-input"
                                           :id="'id_' +index"
                                           :name="'id_' +index"
                                           :checked="false"
                                           :disabled="selectedProducts.includes(product.id)"
                                           @click="selectProductCheckbox(product, $event)"/>
                                    <label class="custom-control-label" :for="'id_' +index"><i class="fa fa-flag"
                                                                                               aria-hidden="true"></i></label>
                                </div>
                            </td>
                            <td>
                                <template v-if="product.quotation">
                                    #{{ product.quotation.quotation_number }}
                                </template>
                            </td>
                            <td>{{ product.product_num }}</td>
                            <td>
                                <p>{{ product.product_name }}</p>
                                <p v-html="product.product_desc"></p>
                            </td>
                            <td>{{ product.qty }}</td>
                            <td>{{ getQuantityUnitName(product.qty_unit_id) }}</td>
                            <td>${{ product.price }}</td>
                            <td><span class="status"> </span></td>
                        </tr>
                    </template>

                </template>

            </template>
            </tbody>

        </table>
    </div>
</template>

<script>
import axios from "axios";
import {mapActions, mapGetters, mapState} from "vuex";
import {ValidationProvider, ValidationObserver} from 'vee-validate';
import SelectedProducts from "./SelectedProducts";

export default {
    name: "QuotationProducts",
    components: {
        ValidationProvider, ValidationObserver, SelectedProducts
    },
    props: ['selectedProducts', 'search_filter', 'bus', 'quotations', 'quantityUnits', 'products'],
    created() {
        if (localStorage.getItem('token')) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        this.getProducts();
    },
    mounted() {
        if (this.search_filter) {
            this.filterForm.search_filter = this.search_filter;
        }
        this.bus.$on('getProducts', this.getProducts);
        this.bus.$on('addNewProduct', (product) => {
            if(this.productData.products.data) {
                this.productData.products.data.push(product);
            }
        });

        window.onscroll = () => {
            let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
            if (bottomOfWindow && this.loadedScrollAllPage == 0) {
                this.current_page += 1;
            }
        }
    },
    data() {
        return {
            productData: {
                products: {
                    data: []
                },
                config: null,
            },
            current_page: 1,
            loadedScrollAllPage: 0,
            per_page: 15,
            total: 0,
            filterForm: {
                search_filter: null,
                status_filter: '1'
            },
            checkAll: true,
            editorConfig: {},
            editorConfigMin: {
                toolbar: []
            },
            qty_unit_id: null
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setQuoteProductsLoading'
        ]),
        getQuantityUnitName(id) {
            if (id != null) {
                let unit = this.quantityUnits.find((x) => x.id == id);
                if (unit) {
                    return unit.name;
                }
            }
            return '';
        },
        checkAllEvent(event) {
            this.productData.products.data.forEach((x) => {
                this.selectProduct(x, event.target.checked);
            });
        },
        tierPeicesChange(product, tier, index, tierIndex, event){
            this.productData.products.data[index].qty = tier.peices;
        },
        selectProductTierCheckbox(product, tier, index, tierIndex, event){
            this.productData.products.data[index].quote_tier_id = tier.id;
            this.productData.products.data[index].qty = tier.peices;
            this.productData.products.data[index].price = tier.price;
        },
        selectProductCheckbox(c, event) {
            this.$emit('selectProduct', {c: c, checked: event.target.checked});
        },
        selectProduct(c, checked) {
            if (checked === null) {
                checked = !this.selectedProducts.includes(c.id);
            }
            this.$emit('selectProduct', {c: c, checked: checked});
        },
        removeProductCheckbox(event) {
            this.$emit('selectProduct', event);
        },
        getProducts() {
            let self = this;
            this.setQuoteProductsLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('so.quotations.products.search', {
                page: this.current_page,
                per_page: this.per_page,
                search_filter: this.filterForm.search_filter,
                status_filter: this.filterForm.status_filter,
                quotations: this.quotations,
                quotation_products: true
            }), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        /*data.data.products.data.forEach((x) => {
                            x.price = "$" + this.strAmountToNumber(x.price);
                            // x.cost = "$" + this.strAmountToNumber(x.cost);
                        });*/

                        data.data.products.data.forEach((x, index) => {
                            let selectedProduct = null;
                            if (this.products != null && this.products.length > 0 &&
                                this.products.filter((xyz) => xyz.quote_product_id == x.id).length > 0) {
                                selectedProduct = this.products.find((xyz) => xyz.quote_product_id == x.id);
                            }

                            // console.log('selectedProduct', selectedProduct);
                            let qty = 0;
                            let qty_unit_id = 0;
                            let qty_tier = 0;
                            if(x.product) {
                                qty = x.product.qty;
                                qty_unit_id = x.product.qty_unit_id;
                                qty_tier = x.product.qty_tier;
                            } else {
                                let qtyPriceDetails = x.quotation_price_detail.filter((qpd) => qpd.deleted == '0' && qpd.selected == '1');
                                if(qtyPriceDetails.length > 0) {
                                    qty = qtyPriceDetails[0].peices;
                                }

                                let quantityUnits = this.quantityUnits.filter((qu) => qu.name.toLowerCase().includes(x.quantity_unit.toLowerCase()));

                                if(quantityUnits.length > 0) {
                                    qty_unit_id = quantityUnits[0].id;
                                }
                            }

                            x.quote_product_id = x.id;
                            x.customer_id = x.product ? x.product.customer_id : null;
                            x.vendor_id = x.product ? x.product.vendor_id : null;
                            x.quote_price_id = x.product ? x.product.quote_price_id : null;
                            x.quote_price_detail_id = x.product ? x.product.quote_price_detail_id : null;
                            x.pieces = x.product ? x.product.pieces : 0;
                            x.vendor_cost = x.product ? x.product.vendor_cost : 0;
                            x.rate = x.product ? x.product.rate : 0;
                            x.selling = x.product ? x.product.selling : 0;
                            x.cost = x.product ? x.product.cost : 0;
                            x.profit = x.product ? x.product.profit : 0;
                            x.product_num = x.product ? x.product.product_num : null;
                            x.product_name = x.product ? x.product.product_name : x.product_name;
                            x.product_desc = x.product ? x.product.product_desc : x.description;

                            if(x.product_tiers && x.product_tiers.length) {
                                x.price = x.product_tiers[0].selling ? x.product_tiers[0].selling : 0;
                            } else {
                                x.price = x.product ? x.product.price : 0;
                            }

                            x.qty = qty;
                            x.uom = x.product ? x.product.uom : 0;
                            x.qty_tier = qty_tier;
                            x.qty_unit_id = qty_unit_id;
                            x.quote_tier_id = null;

                            if(selectedProduct) {
                                x.product_num = selectedProduct.product_num;
                                x.product_name = selectedProduct.product_name;
                                x.product_desc = selectedProduct.product_desc;
                                x.qty = selectedProduct.qty;
                                x.price = selectedProduct.price;
                                x.quote_tier_id = selectedProduct.quote_tier_id ? selectedProduct.quote_tier_id : null;
                            }
                        });

                        if(this.current_page > 1) {
                            if( data.data.products.data.length ==0) {
                                this.loadedScrollAllPage = 1;
                            }
                            this.productData.products.data = this.productData.products.data.concat(_.cloneDeep(data.data.products.data));
                        } else {
                            this.productData = _.cloneDeep(data.data);
                        }
                        this.current_page = data.data.products.current_page;
                        this.per_page = data.data.products.per_page;
                        this.total = data.data.products.total;

                        if (this.checkAll && (this.selectedProducts == null || this.selectedProducts.length == 0)) {
                            this.productData.products.data.forEach((x) => {
                                this.selectProduct(x, true);
                            });
                        }
                        if (this.selectedProducts != null && this.selectedProducts.length > 0 && this.productData.products.data != null) {
                            this.selectedProducts.foreach((id) => {
                               if(this.productData.products.data.filter((x) => x.id == id).length == 0) {
                                   // this.selectProduct(x, false);
                               }
                            });
                            this.productData.products.data.sort((a, b) => {
                                if (this.selectedProducts.includes(a.quote_product_id)) {
                                    return -1;
                                } else if (!this.selectedProducts.includes(a.quote_product_id)) {
                                    return 1;
                                } else {
                                    return 0;
                                }
                            });


                            if (this.productData.products.data.filter((x) => this.selectedProducts.includes(x.id)).length == this.productData.products.data.length) {
                                this.checkAll = true;
                            } else {
                                this.checkAll = false;
                            }
                        }


                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setQuoteProductsLoading(false);

                });
        },
        getSLNo(index) {
            return Number(this.productData.config['start_from']) + index;
        },
        updateProducts(products) {
            //let updatedProducts = products.filter((x) => this.selectedProducts.filter((y) => y == x.id).length > 0);
            //this.$emit('watchChangedProducts', updatedProducts);
            this.$emit('watchChangedProducts', products);
        },
    },
    watch: {
        /*"productData.products.data": {
            handler: function (after, before) {
                after.forEach((x, index) => {
                    this.productData.products.data[index].unit_price = this.strAmountToNumber(x.price);
                    let sum = this.strAmountToNumber(x.price) * x.qty;
                    if (!isNaN(sum)) {
                        this.productData.products.data[index].cost = sum;
                        after[index].cost = sum;
                    }

                });
                this.updateProducts(after);
            },
            deep: true,
        },*/
        qty_unit_id: {
            handler: function (value) {
                if (value !== null && value !== '') {
                    this.products.forEach((product) => {
                        if(product.quote_product_id) {
                            product.qty_unit_id = value;
                        }
                    });
                }
            }
        },
        current_page: {
            handler: function (value) {
                if (value != 1) {
                    this.getProducts();
                }
            }
        },
        search_filter: {
            handler: function (value) {
                this.filterForm.search_filter = value;
            }
        },
        selectedProducts: {
            handler: function (value, oldValue) {
                //console.log(value, oldValue)
                if (value != null && value.length > 0 && this.productData.products.data != null) {
                    this.productData.products.data.sort((a, b) => {
                        if (value.includes(a.id)) {
                            return -1;
                        } else if (!value.includes(a.id)) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                }
                if (value != null && this.productData.products.data != null &&
                    this.productData.products.data.filter((x) => value.includes(x.id)).length == this.productData.products.data.length) {
                    this.checkAll = true;
                } else {
                    this.checkAll = false;
                }
            }
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
        ])
    }
}
</script>

<style scoped>
.error {
    color: red;
}

.product-list-item {
    transition: all 1s;
}

.product-list-enter,
.product-list-leave-to {
    max-height: 0px;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    overflow: hidden;
}

.product-list-enter-to,
.product-list-leave {
    max-height: 80px;
}

.product-table-item {
    transition: all 1s;
}

.product-table-item > * {
    transition: all 1s;
    overflow: hidden;
}

.product-table-enter,
.product-table-leave-to {
    line-height: 0;
}

.product-table-enter > *,
.product-table-leave-to > * {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
}

.product-table-enter-to,
.product-table-leave {
    line-height: 1.5;
}
</style>
